/**
 * Токены, по которым может проходить путь снабжения
 */
export const SUPPLY_UNPASSABLE_TOKENS = [
  'mountain',
  'sea',
];

export const ADDITIONAL_SUPPLY_SPEED = 1;